import { render } from "./PayslipViewModal.vue?vue&type=template&id=7ccae978&scoped=true"
import script from "./PayslipViewModal.vue?vue&type=script&lang=js"
export * from "./PayslipViewModal.vue?vue&type=script&lang=js"

import "./PayslipViewModal.vue?vue&type=style&index=0&id=7ccae978&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ccae978"]])

export default __exports__